import React from 'react';
import { Box, Section } from '@tishman/components';
import { H } from '@hzdg/sectioning';

import { PrivateEventsGalleryCarousel } from './PrivateEventsGalleryCarousel';
import { TPrivateEventsGalleryCarouselItem } from './useCarousel';

type TPrivateEventsGallery = {
  title?: string;
  items?: TPrivateEventsGalleryCarouselItem[];
  id?: string;
};

export const PrivateEventsGallery = ({
  title,
  items = [],
  id = 'gallery',
}: TPrivateEventsGallery) => {
  return (
    <Section id={id} sx={{ paddingBottom: [5, 7] }} theme="Rock Center">
      <Box
        sx={{
          padding: ['0 20px', '0 72px'],
          maxWidth: '1440px',
          margin: '0 auto',
        }}
      >
        {title && (
          <H
            sx={{
              variant: 'styles.h1',
              marginBottom: 0,
              fontFamily: 'headingSecondary',
            }}
          >
            {title}
          </H>
        )}
      </Box>

      {items && <PrivateEventsGalleryCarousel items={items} />}
    </Section>
  );
};
